import {
  ToggleRow,
  NavRow,
} from "./SettingsUIComponents";

interface ToolsSectionProps {
  readonly hasFocusTask: boolean;
  readonly showPomodoro: boolean;
  readonly showTwenty: boolean;
  readonly showStopwatch: boolean;
  readonly onPomodoro: () => void;
  readonly onTwenty: () => void;
  readonly onStopwatch: () => void;
  readonly onFocusMode: () => void;
  readonly onTimerSettings: () => void;
  readonly onAchievements: () => void;
  readonly onTutorial: () => void;
}

export function ToolsSection({
  hasFocusTask,
  showPomodoro,
  showTwenty,
  showStopwatch,
  onPomodoro,
  onTwenty,
  onStopwatch,
  onFocusMode,
  onTimerSettings,
  onAchievements,
  onTutorial,
}: ToolsSectionProps) {
  return (
    <div className="flex flex-col gap-4">
      <ToggleRow
        label="Pomodoro"
        description="Minuteur de productivité 25/5 min"
        checked={showPomodoro}
        onChange={onPomodoro}
      />
      <ToggleRow
        label="20-20-20"
        description="Rappel de pause pour les yeux"
        checked={showTwenty}
        onChange={onTwenty}
      />
      <ToggleRow
        label="Chronomètre"
        description="Chronomètre libre avec tours"
        checked={showStopwatch}
        onChange={onStopwatch}
      />
      {hasFocusTask && <NavRow label="Mode Focus" accent onClick={onFocusMode} />}
      <NavRow label="Réglages minuteurs" onClick={onTimerSettings} />
      <NavRow label="Accomplissements" onClick={onAchievements} />
      <NavRow label="Revoir le tutoriel" onClick={onTutorial} />
    </div>
  );
}
